import template from './bulk_cash_management.html';
import controller from './bulk_cash_management.controller';
import './bulk_cash_management.scss';

let bulkCashManagementComponent = {
  restrict: 'E',
  template,
  controller
};

export default bulkCashManagementComponent;

     


// WEBPACK FOOTER //
// ./client/app/components/bulk_cash_management/bulk_cash_management.component.js